module.exports = __webpack_public_path__ + "static/media/screenshot(18).e387c897.jpg";